export default "__VITE_ASSET__CbcyNlaL__"